module.exports = __webpack_public_path__ + "static/img/Ncs-Selected.f082172.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Ncs-Selected.png
// module id = 274
// module chunks = 0